"use client";

import { ComparisonTable } from "@/components/compare/comparison-table";

export function ComparisonPortkey() {
	return <ComparisonTable competitor="portkey" />;
}
